/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { Injectable } from '@angular/core';
import { SupplierUserContext } from '@gh/supplier-shared';
import { SupplierSharedDocsRestService } from '@gh/supplier-shared-data';
import * as i0 from "@angular/core";
import * as i1 from "@gh/supplier-shared";
import * as i2 from "@gh/supplier-shared-data";
var SupplierSharedDocsListBusinessService = /** @class */ (function () {
    function SupplierSharedDocsListBusinessService(userContext, restService) {
        this.userContext = userContext;
        this.restService = restService;
    }
    SupplierSharedDocsListBusinessService.prototype.getAll = function () {
        return this.restService.getAll();
    };
    SupplierSharedDocsListBusinessService.ɵfac = function SupplierSharedDocsListBusinessService_Factory(t) { return new (t || SupplierSharedDocsListBusinessService)(i0.ɵɵinject(i1.SupplierUserContext), i0.ɵɵinject(i2.SupplierSharedDocsRestService)); };
    SupplierSharedDocsListBusinessService.ɵprov = i0.ɵɵdefineInjectable({ token: SupplierSharedDocsListBusinessService, factory: SupplierSharedDocsListBusinessService.ɵfac });
    return SupplierSharedDocsListBusinessService;
}());
export { SupplierSharedDocsListBusinessService };
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SupplierSharedDocsListBusinessService, [{
        type: Injectable
    }], function () { return [{ type: i1.SupplierUserContext }, { type: i2.SupplierSharedDocsRestService }]; }, null); })();
